import React from "react";
import Modal from "../modal/Modal";
import { Button } from "../buttons";

function ResetPasswordConfirmModal({ openModal, setOpenModal, onConfirm }) {
  return (
    <Modal size="md" show={openModal} onClose={() => setOpenModal(false)}>
      <Modal.Header>
        パスワードのリセットを確認します
      </Modal.Header>
      <Modal.Body>
        <p>ユーザーのパスワードをデフォルトのパスワードにリセットしますか?</p>
      </Modal.Body>
      <Modal.Footer className="flex justify-center space-x-[20px]">
        <Button color="light" className="w-[240px]" onClick={() => setOpenModal(false)} children="キャンセル" />
        <Button color="primary" className="w-[240px]" onClick={onConfirm} children="パスワードをリセット" />
      </Modal.Footer>
    </Modal>
  );
}

export default ResetPasswordConfirmModal;
